import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import SuggestionSearchInputNew from 'components/desktop/_general/Input/SuggestionSearchInput/SuggestionSearchInputNew';
import ListItem from 'components/desktop/_general/ListItem/ListItem';
import * as SelectItem from 'types/_general/SelectItem';
import * as SelectItemList from 'types/_general/SelectItemList';

type Position = 'top' | 'bottom';

interface IProps {
	allItems: SelectItemList.Type;
	className?: string;
	displaySavedItems: Position;
	errorKey?: string;
	label?: string;
	savedItems: string[];
	setSavedItems: (input: string[]) => void;
}

const MultiSearchSelectNew = (props: IProps) => {
	const handleAddItem = (item: string) => {
		const resultItems = props.savedItems;
		resultItems.push(item);
		props.setSavedItems(resultItems);
	};

	return (
		<div className={props.className ? `row ${props.className}` : 'row'}>
			<RenderIf condition={props.label != undefined}>
				<label>{props.label}</label>
			</RenderIf>
			<div className="col-12">
				<RenderIf condition={props.displaySavedItems === 'top'}>
					{SelectItemList.mapFromStringArray(props.allItems, props.savedItems).map(
						(item: SelectItem.Type, i: number) => (
							<div
								className="d-block d-flex justify-content-between select-saveditems"
								key={i}
							>
								{item.name}
								<span
									onClick={() =>
										props.setSavedItems(
											props.savedItems.filter((x) => x != item.id)
										)
									}
								>
									<i className="bi bi-x" />
								</span>
							</div>
						)
					)}
				</RenderIf>
				<div className="input-group" style={{ display: 'flex' }}>
					<SuggestionSearchInputNew
						errorKey={props.errorKey}
						setSavedItem={handleAddItem}
						allItems={props.allItems}
						savedItems={props.savedItems}
					/>
				</div>
				<RenderIf condition={props.displaySavedItems === 'bottom'}>
					<div className="mt-2 overflow-auto">
						{SelectItemList.mapFromStringArray(props.allItems, props.savedItems).map(
							(item: SelectItem.Type, i: number) => (
								<ListItem
									key={i}
									text={item.name}
									title={item.title ?? undefined}
									iconSvgUrl={item.iconSvgUrl}
									handleDelete={() =>
										props.setSavedItems(
											props.savedItems.filter((x) => x != item.id)
										)
									}
								/>
							)
						)}
					</div>
				</RenderIf>
			</div>
		</div>
	);
};

export default MultiSearchSelectNew;
